import type React from 'react';
import { TransactionsView } from './TransactionsView';
import { useTransactionsPage } from './useTransactionsPage';

/**
 * Transactions — the first page of the admin app. Lists the selected day's
 * sales for the branch. Thin container: page state in `useTransactionsPage`,
 * layout in `TransactionsView`, data in the self-served list section.
 */
export const Transactions: React.FC = () => {
    const logic = useTransactionsPage();
    return <TransactionsView {...logic} />;
};
